import { createFeatureSelector, createSelector } from '@ngrx/store';
import { companyAdapter, CompanyState } from './company.reducer';
import * as CompanyReducer from './company.reducer';

export const getCompanyState = createFeatureSelector<CompanyState>('companies');

export const {
  selectAll: getAllCompanies,
  selectEntities: getCompanyEntities,
  selectIds: getCompanyIds,
  selectTotal: getTotalCompanies,
} = companyAdapter.getSelectors(getCompanyState);

export const getCurrentPage = createSelector(
  getCompanyState,
  (state: CompanyState) => state.currentPage
);

export const getTotalPages = createSelector(
  getCompanyState,
  (state: CompanyState) => state.totalPages
);

export const getTotalItems = createSelector(
  getCompanyState,
  (state: CompanyState) => state.totalItems
);

export const getLoading = createSelector(
  getCompanyState,
  (state: CompanyState) => state.loading
);
export const selectAllCompanies = createSelector(
  getCompanyState,
  CompanyReducer.selectAllCompanies
);

export const getSelectedCompany = createSelector(
  getCompanyState,
  (state: CompanyState) => state.selectedCompany
);

export const getNetworkChart = createSelector(
  getCompanyState,
  (state: CompanyState) => state.network_chart
);
export const getInfluenceChart = createSelector(
  getCompanyState,
  (state: CompanyState) => state.influence_chart
);
export const getPerformanceChart = createSelector(
  getCompanyState,
  (state: CompanyState) => state.performance_chart
);

export const getTop10Companies = createSelector(
  getCompanyState,
  (state: CompanyState) => state.top10Companies
);

export const getTop3Companies = createSelector(
  getCompanyState,
  (state: CompanyState) => state.top3Companies
);

export const getTopShortListCompanies = createSelector(
  getCompanyState,
  (state: CompanyState) => state.topShortListCompanies
);
